import React from 'react'

const Span = ({ ...props }) => {
    const { children, className } = props
    return (
        <span className={className}>{children}</span>
    )
}

export default Span